// import appLocaleData from 'react-intl/locale-data/en';

const EnLang = {
    messages: {
    },
    locale: 'en-US',
    // data: appLocaleData
};
export default EnLang;